import { powodOdmowy } from './powodOdmowy';

/** Wywołanie RPC klienta Supabase (`(n, a) => supabase.rpc(n, a)`) — bez zależności pakietu od klienta. */
export type WywolajRpc = (
  nazwa: string,
  argumenty: Record<string, unknown>
) => PromiseLike<{ error: unknown }>;

/**
 * Czy organizacja przyjmuje nowe karty produktów z panelu (UD-23, plan 54 §9 p. 9 i §16.2).
 *
 * Gdy kartotekę organizacji prowadzi włączone źródło (np. Receptor), baza odmawia zakładania karty w panelu:
 * `kartoteka_zakladanie_dozwolone` zgłasza `23001` ze zdaniem dla człowieka i podpowiedzią — to zdanie wraca
 * stąd, a ekran wyłącza nim przycisk „Dodaj produkt”. Brak źródła → `null`.
 *
 * Każdy inny wynik (brak uprawnień 42501, błąd sieci, wyjątek klienta) → `null`: sprawdzenie z góry jest
 * podpowiedzią, odmowę i tak wydaje baza przy zapisie (polityka `products_insert_kartoteka`), a ekran pokazuje
 * ją wtedy przez `powodOdmowy`. Awaria odczytu nie może więc zabrać panelowi przycisku.
 */
export async function blokadaZakladaniaKarty(
  rpc: WywolajRpc,
  organizacjaId: string
): Promise<string | null> {
  try {
    const { error } = await rpc('kartoteka_zakladanie_dozwolone', {
      p_organization_id: organizacjaId,
    });
    if (!error) return null;
    const zdanie = powodOdmowy(error, '');
    return zdanie === '' ? null : zdanie;
  } catch {
    return null;
  }
}
